import { cloneDeep } from "lodash";

export const deepCopy = (item) => {
    return cloneDeep(item);
};
